import React, { useState } from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as Constants from '../../../../constants'
import { Form, message } from 'antd'
import { newItemInventory } from '../../../../actions/inventory'
import FormToolInventory from '../../../containers/FormToolInventory'
import './styles.css'

const NewTool = (props) => {
    const [filterTools, setFilterTools] = useState('')
    const [isSaving, setIsSaving] = useState(false)

    const [form] = Form.useForm()

    const handleSubmitNewTool = async values => {
        setIsSaving(true)
        const response = await props.newItemInventory(values)
        setIsSaving(false)
        if (response) {
            message.success('La herramienta se guardó exitósamente')
            props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const handleBack = () => {
        props.history.goBack()
    }

    return (
        <Grid className="newToolCont">
            <Row center="xs">
                <Col xs={12}>
                    Nueva herramienta - Inventario
                </Col>
            </Row>
            <br/>
            <Row center="xs">
                <Col xs={12} sm={10}>
                    <FormToolInventory loading={isSaving} onSubmitToolInventory={handleSubmitNewTool}
                                          isEditing={false} onBack={handleBack}/>
                </Col>
            </Row>
        </Grid>
    )
}

const mapDispatchToPropsActions = dispatch => ({
    newItemInventory: value => dispatch(newItemInventory(value))
})

const mapStateToProps = state => ({})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewTool))
